// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accordion {
  border-radius: 12px;
  background-color: #262626;
}

.accordion__item {
  border-bottom: 1px solid #373737;
}

.accordion__item:last-child {
  border: unset;
}

.accordion__text {
  color: #FFFFFF;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-align: start;
}

.accordion__button {
  width: 100%;
  display: flex;
  justify-content: space-between;
  background-color: unset;
  padding: 16px 16px 8px 16px;
}

.accordion__description {
  padding: 0 16px 16px 16px;
  color: #FFFFFF;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
}
`, "",{"version":3,"sources":["webpack://./src/components/accordion/Accordion.scss","webpack://./src/components/accordion/Accordion.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yBAAyB;ACC3B;;ADCE;EACE,gCAAgC;ACEpC;;ADHG;EAIG,aAAa;ACGnB;;ADCE;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;ACErB;;ADCE;EACE,WAAW;EAGX,aAAA;ECIM,8BAA8B;EDAtC,uBAAe;EACb,2BAAyB;ACE7B;;AAEA;EDAI,yBAAgB;EAChB,cAAa;EACd,eAAA;ECED,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":[".accordion {\n  border-radius: 12px;\n  background-color: #262626;\n\n  &__item {\n    border-bottom: 1px solid #373737;\n\n    &:last-child {\n      border: unset;\n    }\n  }\n\n  &__text {\n    color: #FFFFFF;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    text-align: start;\n  }\n\n  &__button {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    background-color: unset;\n    padding: 16px 16px 8px 16px;\n  }\n\n  &__description {\n    padding: 0 16px 16px 16px;\n    color: #FFFFFF;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 22px;\n  }\n}",".accordion {\n  border-radius: 12px;\n  background-color: #262626;\n}\n\n.accordion__item {\n  border-bottom: 1px solid #373737;\n}\n\n.accordion__item:last-child {\n  border: unset;\n}\n\n.accordion__text {\n  color: #FFFFFF;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  text-align: start;\n}\n\n.accordion__button {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  background-color: unset;\n  padding: 16px 16px 8px 16px;\n}\n\n.accordion__description {\n  padding: 0 16px 16px 16px;\n  color: #FFFFFF;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 22px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
